import {
  CURRENT_YEAR_LABEL,
  CUSTOM_LABEL,
  DATES_LABEL, DEFAULT_WEEK_COMPARE_TO_DATA,
  PRACTICES_LABEL,
  SELECT_LABEL
} from '../../../../config/constants';
import { Dispatch, SetStateAction } from 'react';
import { Week } from '../../../../store/types';
import { RangeDate } from '../../../../config/commonTypes';

export const selectedDataNull = {
  compareTo: null,
  default: null,
  year: null,
  week: DEFAULT_WEEK_COMPARE_TO_DATA,
  isUseInProgressComps: null,
  isUseSameIntensity: null,
  selectedIdPractices: null,
};

export type DateRangeSelectorDataType<T> = {
  selectedDates: RangeDate[], // array of range dates
  default: 7 | 14 | 28 | typeof CURRENT_YEAR_LABEL | typeof CUSTOM_LABEL,
  year: number | typeof SELECT_LABEL | '',
  week: T,//Week | typeof CUSTOM_LABEL | typeof ALL_SEASON_YEAR, // week object
  isUseInProgressComps?: boolean, // only on live practices
  isUseSameIntensity?: boolean, // only on live and post practices
  includeGamesInComparisonAvg?: boolean, // only on live and post practices
  selectedIdPractices: string[], // id practices selected
  compareTo: typeof DATES_LABEL | typeof PRACTICES_LABEL | '',
  threshold: number | typeof SELECT_LABEL | ''
}

export type DateRangeSelectorPropsType = {
  show: boolean, // true: unfolded, false: not unfolded
  close: () => void, // to close the dropdown
  open: () => void, // to open the dropdown
  loadData: () => void, // action when apply is clicked
  onlyOne?: boolean, // true: only one range date can be selected
  initialDate?: Date | number, // initial date for 7, 14, 28 default past days
  practicesTab?: { yearSeason: number, teamId: string }, // true: with tab practices
  forceScope: string, // scope to force
  isNcaa?: boolean
}

// Props for ./YearSelector/PracticeBadge.tsx
export type YearSelectorPropsType = {
  newData: DateRangeSelectorDataType<Week>,
  setNewData: Dispatch<SetStateAction<DateRangeSelectorDataType<Week>>>,
  changeViewMonths: (date: Date) => void
}

// Props for ./ThresholdSelector/PracticeBadge.tsx

export type ThresholdSelectorPropsType = {
  newData: DateRangeSelectorDataType<Week>,
  setNewData: Dispatch<SetStateAction<DateRangeSelectorDataType<Week>>>
}
// Props for ./SmallCalendar/SmallMonthRows/PracticeBadge.tsx
export type SmallMonthRowsPropsType = {
  monthShown: Date,
  selectedDates: RangeDate[],
  click: (copyDay: Date) => void,
  newData: DateRangeSelectorDataType<Week>,
  currentDate: Date
}

// Props for ./SmallCalendar/PracticeBadge.tsx
export type SmallCalendarPropsType = {
  monthShown: Date,
  newSelectedDates: RangeDate[],
  click: (copyDate: Date) => void,
  newData: DateRangeSelectorDataType<Week>,
  currentDate: Date,
}

// Props for ./SeasonWeekSelector/PracticeBadge.tsx
export type SeasonWeekSelectorPropsType = {
  newData: DateRangeSelectorDataType<Week>,
  setNewData: (data: DateRangeSelectorDataType<Week>) => void,
  changeViewMonths: (date: Date) => void,
  weeksData: Week[],
}

// Props for ./Default/PracticeBadge.tsx
export type DefaultPropsType = {
  newData: DateRangeSelectorDataType<Week>,
  setNewData: (data: DateRangeSelectorDataType<Week>) => void,
  changeViewMonths: (date: Date) => void,
  now: Date | number,
  specificScope: string
}